import { render, staticRenderFns } from "./StreamerDeviceTab.vue?vue&type=template&id=8febf3dc&scoped=true&"
import script from "./StreamerDeviceTab.vue?vue&type=script&lang=js&"
export * from "./StreamerDeviceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8febf3dc",
  null
  
)

export default component.exports